<template>
    <v-card v-if="pokemon!== undefined" class="skin-pokemon-card pokemon-detail-card" :height="minHeight">
        <v-card-text width="100%" height="100%" class="pt-1 fill-height pokemon-detail-text">
            <!-- Škálování karty přes CSS `zoom` (ne transform:scale) - viz
                 claude/components/team-sheet.md. -->
            <v-card-title class="text-no-wrap ma-0 pa-0">
                <v-container class="ma-0 pokemon-detail-name-wrap" :class="$vuetify.theme.dark ? 'white--text' : 'black--text'" style="z-index: 9;">
                    <div class="pokemon-detail-hp-stack">
                        <PokemonProgressBar
                            v-if="isOwnPokemon && pokemon.evolveProgress !== undefined && pokemon.evolveProgress !== null"
                            :percent="pokemon.evolveProgress"
                            variant="evolve"
                            :height="3"
                        />
                        <v-progress-linear
                            background-color="bar-hp-red"
                            color="bar-hp-green"
                            height="8"
                            rounded
                            style="position: relative; z-index: -1;"
                            class="caption pa-0 ma-0"
                            min-width="50"
                            :value="getHp()"
                        >
                            <div
                                class="pl-1 pr-1 mr-2"
                                :style="`box-shadow: 0 0 8px 12px ${$vuetify.theme.dark ? 'rgba(0,0,0,0.63)' : 'rgba(255,255,255,0.63)'}; background-color: ${$vuetify.theme.dark ? 'rgba(0,0,0,0.63)' : 'rgba(255,255,255,0.63)'}; border-radius: 40%; position:relative; top: 0px; z-index: 10;`"
                            >
                                <v-spacer /><strong class="pd-hp-text"> {{ pokemon.hp }}/{{ pokemon.maxHp }}</strong>
                            </div>
                        </v-progress-linear>
                        <PokemonProgressBar
                            v-if="isOwnPokemon && pokemon.levelProgress !== undefined && pokemon.levelProgress !== null"
                            :percent="pokemon.levelProgress"
                            variant="level"
                            :height="3"
                        />
                    </div>
                    <!-- Jmeno badge je zamerne VZDY svetle pozadi + cerny text, bez ohledu na
                         $vuetify.theme.dark (zadani uzivatele 2026-09-02) - na tmave karte by
                         tmavy translucentni podklad splynul s pozadim a jmeno by nebylo citelne. -->
                    <span class="pa-1" style="font-size: 1.2em; position: relative; background-color: rgba(255,255,255,0.63); color: #000; border-radius: 5px; z-index: -2; zoom: var(--pd-name-scale, 1); display: inline-block;">{{getPokemonName()}}</span>
                </v-container>
                <v-spacer/>
                <v-hover v-slot="{ hover }">
                    <v-btn
                        v-show="chooseToFight !== undefined"
                        class="ma-3 black--text btn-shadow"
                        :color="`${hover? 'secondary': 'primary'}`"
                        :loading="isLoading"
                        :disabled="pokemon.hp < 1"
                        fab
                        width="60"
                        height="60"

                        style="position:absolute; right:0; top:0; z-index:10;"
                        @click="chooseToFightButton(pokemon)"
                    >
                        <v-avatar>
                            <v-img
                                src='@/assets/pic/web/pokeball.png'
                                width="60"
                                height="60"
                            />
                        </v-avatar>
                    </v-btn>
                </v-hover>
              <!-- Free exp se v boji neukazuje vubec (i u vlastniho pokemona) - zadani
                   uzivatele 2026-09-02, rusi to od hry v aktivnim souboji. Level bublina
                   zustava vzdy (i pro souperova pokemona), to je zamerne beze zmeny. -->
              <PokemonLevelBadge
                  :level="pokemon.level"
                  :free-exp="isOwnPokemon && !fight && pokemon.pokemonExperience ? pokemon.pokemonExperience.freeExp : null"
                  class="pokemon-detail-level-badge"
              />
            </v-card-title>
            <PokemonCardBadges
                :pokemon="badgesPokemon"
                :items="items"
                :show-item-button="allowUseItem && isOwnPokemon"
                :in-fight="fight"
                :dialog-stones="dialogStones"
                class="pokemon-detail-badges"
                @item-used="onItemUsed"
                @item-use-error="$emit('item-use-error', $event)"
                @evolve="evolvePokemon"
            />
            <!-- top:0 + bottom:0 (bez height propsy) nechá výšku dopočítat
                 z rozestupu, aby se obrázek vždy roztáhl na celou dostupnou
                 výšku karty (i výrazně nižší než 400px, viz minHeight prop). -->
            <v-img
                class="self-center pokemon-detail-icon"
                :src="getIcon"
                contain
                :style="[{position: 'absolute', top: '0px', bottom: '0px', left: '0px'}, getIconStyle]"
            />
            <!-- Bojové efekty na kartě pokémona - detekce viz watch na
                 hitReport ve scriptu. Návrh fronty efektů/shieldBlock viz
                 claude/components/team-sheet.md. -->
            <img
                v-if="activeEffect && activeEffect !== 'shieldBlock'"
                :key="activeEffectKey"
                :src="activeEffectSrc"
                class="pokemon-detail-effect-overlay"
                :class="{
                    'pokemon-detail-effect-overlay--screen': activeEffect === 'hitImpact',
                    'pokemon-detail-effect-overlay--compact': activeEffect === 'healLifesteal' || activeEffect === 'poisonDrops',
                }"
                :style="effectOverlayStyle"
                alt=""
            />
            <!-- Štít - statický obrázek + shine pruh uvnitř wrapperu, který
                 nese pozici/zrcadlení - vnitřní prvky pak mají vlastní
                 keyframe animaci na transform/opacity nezávisle na wrapperu. -->
            <div
                v-if="activeEffect === 'shieldBlock'"
                :key="activeEffectKey"
                class="pokemon-detail-effect-overlay pokemon-detail-effect-overlay--shield"
                :style="shieldOverlayStyle"
            >
                <img :src="shieldOverlayImg" class="pokemon-detail-shield-img" alt="" />
                <!-- Lesk jen pro normální/mirror variantu - pierce (prasklý
                     štít) lesk nemá. -->
                <div
                    v-if="!isPierceBreak"
                    class="pokemon-detail-shield-shine"
                    :style="{'-webkit-mask-image': `url(${shieldOverlayImg})`, maskImage: `url(${shieldOverlayImg})`}"
                />
            </div>
            <img
                v-if="showStunnedLoop"
                :key="stunnedLoopKey"
                :src="stunnedGif"
                class="pokemon-detail-effect-overlay pokemon-detail-effect-overlay--compact pokemon-detail-effect-overlay--stunned"
                :style="effectOverlayStyle"
                alt=""
            />
            <div
                v-if="showMissStreak"
                class="pokemon-detail-miss-streak"
            />
            <!-- Wrapper je position:absolute, kotví ho .pokemon-detail-card's
                 position:relative - hvězdička je uvnitř POZIČNĚ vázaná na roh
                 tlačítka (position:absolute vůči tomuto wrapperu), ne na
                 vlastní nezávisle doladěný offset - dřív "utíkala" mimo
                 pilulku, protože oba prvky měly jen náhodou podobné magic-
                 number odsazení (hlášeno uživatelem 2026-09-02). -->
            <div
                v-if="showDetails"
                class="pokemon-detail-skills-wrap"
                :class="{'pokemon-detail-skills-wrap--mirrored': rightHanded}"
            >
                <!-- `small` + tier skala --pd-skills-scale: stejne tlacitko
                     jako v PokemonManager.vue (28px) pri sirokych kartach,
                     zmensuje se az v battle tierech. -->
                <v-btn
                    rounded
                    small
                    :loading="loading"
                    class="skin-btn-skills"
                    @click="toggleStats"
                > {{ $t('pokemon.common.skillsButton') }}</v-btn>
                <!-- Zlatá hvězdička "může se naučit nový skill" - stejná
                     konvence jako PokemonManager.vue/OakTable.vue/
                     TeamBottomSheet.vue (#FFD700 "victoryGold"). Sedí na
                     horním rohu tlačítka, většinou plochy NA něm. -->
                <v-icon
                    v-if="pokemon.posibleBuySkill"
                    size="18"
                    class="pokemon-detail-skills-star"
                >mdi-star</v-icon>
            </div>
        </v-card-text>

        <!-- SKILL DIALOG - sdílená "skillpopup" identita se SkillPopup.vue
             (pokedex)/PokemonManager.vue, protože je to koncepčně totéž
             ("skills achievable/known by X"). Typové barvy skin neřeší,
             viz claude/architecture/frontend.md §9. -->
        <v-row v-if="pokemon && pokemon.pokemonType" justify="center">
            <ResponsiveDialog
                v-model="show"
                :max-width="820"
                :full-height="false"
                :header-title="$t('pokemon.pokemonDetail.skillsDialogTitle', {name: pokemon.pokemonType.name})"
                header-class="skin-window-header--skillpopup"
                card-class="skin-card"
            >
                <div class="skin-window--skillpopup pokemon-detail-skills-bg">
                    <v-card-text class="transparent03 justify-center pokemon-detail-skills-content">
                        <SkillDialogHeader
                            :img="getIcon"
                            :img-style="getIconStyle"
                            :img-alt="pokemon.name || pokemon.pokemonType.name"
                            :level="pokemon.level"
                            :free-exp="pokemon.pokemonExperience ? pokemon.pokemonExperience.freeExp : null"
                            :exp="pokemon.pokemonExperience ? pokemon.pokemonExperience.exp : null"
                        />

                        <SkillListTable
                            v-if="displayedSkillItems && displayedSkillItems.length > 0"
                            :items="displayedSkillItems"
                            :mode="allowBuySkills ? 'buy' : 'view'"
                            :pokemon="allowBuySkills ? pokemon : null"
                            :loading="skillBuyLoading"
                            @open-detail="openSkillDetail"
                            @buy="buyNewSkill"
                        />
                        <p v-else-if="pokemon.pokemonType.isDitto" style="text-align:center;" class="ma-4">
                            {{ $t('pokemon.common.dittoNoSkills') }}
                        </p>
                        <p v-else style="text-align:center;"> {{ $t('pokemon.pokemonDetail.noSkillsMessage', {name: pokemon.name}) }}</p>
                    </v-card-text>
                </div>
            </ResponsiveDialog>
            <!-- Detail popup po kliknutí na řádek - stejný SkillDetailPopup
                 jako Skills.vue (Pokedex) / PokemonManager.vue, jen bez
                 known-obstacle-types (default [] = žádná hláška o rozbití
                 obstacle). -->
            <SkillDetailPopup v-model="skillDetailOpen" :skill="selectedSkill" />
            <!-- DIALOG EEVEE EVOLVE - stejná .skin-window--oak identita jako
                 PokemonManager.vue. -->
            <ResponsiveDialog
                v-model="showEeveeStones"
                :max-width="800"
                :full-height="false"
                :header-title="$t('pokemon.common.eeveeDialogTitle', {name: pokemon.name})"
                header-class="skin-window-header--oak"
                card-class="skin-card"
            >
                <div class="skin-window--oak eevee-stones-bg">
                    <div class="eevee-stones-content">
                        <v-img
                            v-if="evolveEvveePokemon"
                            :src="evolveImg(evolveEvveePokemon.img)"
                            :alt="evolveEvveePokemon.name"
                            height="150"
                            contain
                            class="eevee-stones-pokemon-img"
                        />
                        <div v-if="dialogStones && dialogStones.length > 0" class="eevee-stones-grid">
                            <v-tooltip
                                v-for="stone in dialogStones"
                                :key="stone.id"
                                bottom
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <div
                                        class="eevee-stone-tile"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="evolveEevee(stone.id, evolveEvveePokemon.number)"
                                    >
                                        <v-img
                                            :src="require(`@/assets/pic${stone.picture}`)"
                                            class="eevee-stone-tile-img"
                                            contain
                                        />
                                        <div class="eevee-stone-tile-label">{{ $t('pokemon.common.eeveeStonePower', {value: stone.stoneVal}) }}</div>
                                    </div>
                                </template>
                                <div style="max-width: 100px;">
                                    {{ $t('pokemon.common.eeveeStoneTooltip', {name: pokemon.name, stoneName: stone.name, value: stone.stoneVal}) }}
                                </div>
                            </v-tooltip>
                        </div>
                        <v-card-title v-else-if="evolveEvveePokemon" class="justify-center">{{ $t('pokemon.common.eeveeNoStone', {type: evolveEvveePokemon.type}) }}</v-card-title>
                    </div>
                </div>
            </ResponsiveDialog>
        </v-row>
        <ConfirmDialog ref="confirmDialog"/>
    </v-card>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import {API_ENTRYPOINT} from "@/config/entrypoint";
    import ResponsiveDialog from "@/components/utils/ResponsiveDialog";
    import SkillListTable from "@/components/pokedex/SkillListTable";
    import SkillDetailPopup from "@/components/pokedex/SkillDetailPopup";
    import ConfirmDialog from "@/components/utils/ConfirmDialog";
    import {pokemonImageSrc} from '@/utils/pokemonImage';
    import PokemonProgressBar from '@/components/pokemon/PokemonProgressBar';
    import SkillDialogHeader from '@/components/pokemon/SkillDialogHeader';
    import PokemonCardBadges from '@/components/pokemon/PokemonCardBadges';
    import PokemonLevelBadge from '@/components/pokemon/PokemonLevelBadge';
    import {flags} from '@/config/featureFlags';

    // Délky odpovídají offline předzpracovaným assetům (ne přirozeným
    // délkám zdrojových gifů) - gify hrají svou přirozenou rychlostí snímků,
    // jen se ořežou na tento strop. shieldBlock hodnota MUSÍ odpovídat délce
    // CSS animace pokemon-detail-shield-appear (1.5s), jinak by JS timeout
    // skryl obrázek dřív/později, než animace doběhne.
    const EFFECT_DURATIONS_MS = {
        hitImpact: 740,
        healLifesteal: 2000,
        poisonDrops: 2000,
        shieldBlock: 1500,
    };
    // Remiza (CSS-only) - zadny gif, jen kratky bily odlesk pres kartu.
    const MISS_STREAK_DURATION_MS = 400;

    export default {
        components: {ResponsiveDialog, SkillListTable, SkillDetailPopup, ConfirmDialog, PokemonProgressBar, SkillDialogHeader, PokemonCardBadges, PokemonLevelBadge},
        props: {
            pokemon: {type: Object, default: undefined},
            opponentPokemon: {type: Object, default: undefined},
            unknown: {type: Boolean, default: false},
            chooseToFight: {type: Function, undefined},
            fight: {type: Boolean, default: false},
            showStats: {type: Boolean, default: false},
            showDetails: {type: Boolean, default: true},
            forceSkills: {type: Boolean, default: false},
            // Zapíná nákup skillu (mode="buy" u SkillListTable) - default
            // false, zapíná jen TeamBottomSheet.vue mimo fight.
            allowBuySkills: {type: Boolean, default: false},
            // Zapíná evolve kouli - stejný volající jako allowBuySkills.
            allowEvolve: {type: Boolean, default: false},
            // Zapíná tlačítko "Použít item" (UseItemButton) - stejný volající
            // jako allowEvolve/allowBuySkills, default false ať se nezobrazí
            // v boji/catch dialogu/výběru startéra.
            allowUseItem: {type: Boolean, default: false},
            items: {type: Array, default: () => []},
            stones: {type: Array, default: () => []},
            side: {type: String, default: null},
            // Number (px) nebo String ("100%" - aktivní souboj, viz
            // CombatantSlot.vue/BattleScreen.vue cardHeight).
            minHeight: {type: [Number, String], default: 360},
            // fight.fightReport2 z BattleScreen.vue - nový objekt každé kolo
            // (viz watch níže), null mimo aktivní souboj.
            hitReport: {type: Object, default: null},
            // fight.beforeAttackRound z BattleScreen.vue - true, když v
            // aktuálním kole útočí trenérův pokémon (Left), false když
            // soupeřův (Right). Viz computed isAttackerThisRound.
            beforeAttackRound: {type: Boolean, default: null},
        },
        data() {
            return {
                show: false,
                loading: false,
                skills: null,
                selectedSkill: null,
                skillDetailOpen: false,
                skillBuyLoading: false,
                showEeveeStones: false,
                evolveEvveePokemon: false,
                dialogStones: [],
                battleEffectGifs: {
                    hitImpact: require('@/assets/pic/web/hit-impact.gif'),
                    healLifesteal: require('@/assets/pic/web/heal-lifesteal.gif'),
                    poisonDrops: require('@/assets/pic/web/poison-drops.gif'),
                },
                // shieldBlock NENÍ v battleEffectGifs - je to statický
                // obrázek (viz šablona) + CSS animace, ne gif přehrávaný přes
                // activeEffectSrc. Který ze tří obrázků se použije, určuje
                // computed shieldOverlayImg podle isReflectBlock/isPierceBreak.
                shieldPokPng: require('@/assets/pic/web/shield-pok.png'),
                mirrorPokPng: require('@/assets/pic/web/mirror-pok.png'),
                piercePokPng: require('@/assets/pic/web/pierce-pok.png'),
                // Aktuální výška karty v px - CSS "width: X%" je vždy
                // relativní k šířce containeru, takže "procento z výšky"
                // nejde vyjádřit čistým CSS. Měřeno přes ResizeObserver
                // (viz mounted/beforeDestroy níže), použito ve shieldOverlayStyle.
                shieldCardHeightPx: 0,
                // Aktuálně zobrazovaný efekt z fronty (viz playEffectQueue) -
                // 'hitImpact' | 'healLifesteal' | 'poisonDrops' | 'shieldBlock' | null
                activeEffect: null,
                // Inkrementuje se při každém novém efektu ve frontě - vynutí
                // Vue překreslit <img> od znova, jinak by už načtený/cachovaný
                // GIF jen "stál" na posledním snímku předchozího přehrání.
                activeEffectKey: 0,
                activeEffectTimeout: null,
                showMissStreak: false,
                missStreakTimeout: null,
                stunnedGif: require('@/assets/pic/web/stunned.gif'),
                // Na rozdíl od activeEffect nemá pevnou dobu zobrazení - hraje
                // nepřetržitě (loop=0 přímo v gifu), dokud ho nezastaví další
                // změna hitReport (viz watch níže).
                showStunnedLoop: false,
                stunnedLoopKey: 0,
            }
        },
        computed: {
            ...mapGetters({
                isLoading: 'journey/isLoading',
                buttonVolume: 'journey/buttonVolume',
            }),
            // "skills" (Pokemon::$skills) jsou skilly, které tenhle KONKRÉTNÍ
            // pokémon už umí - správné pro "view" mód. Pro "buy" mód je
            // potřeba celý katalog skillů TYPU (pokemon.pokemonType.skills),
            // jinak by SkillListTable v buy módu zobrazila jen už vlastněné
            // skilly bez možnosti koupě.
            displayedSkillItems() {
                if (this.allowBuySkills) {
                    return (this.pokemon.pokemonType && this.pokemon.pokemonType.skills) || [];
                }
                return this.skills;
            },
            // Evolve/level bary se smí zobrazit jen u VLASTNÍHO pokémona.
            // side="Right" je jediná spolehlivá značka soupeřova pokémona -
            // všechna ostatní použití této komponenty jsou už vždy vlastní
            // pokémon, stačí vyloučit přesně tento jeden případ.
            isOwnPokemon(){
                return this.side !== 'Right';
            },
            // PokemonCardBadges sama vždy vykreslí evolve orb, když
            // pokemon.evolvable.length > 0 - zachovává se tak dřívější
            // `allowEvolve` gating (jen TeamBottomSheet.vue mimo fight) tím,
            // že se komponentě předá prázdné evolvable pole, pokud allowEvolve
            // není zapnuté.
            badgesPokemon() {
                if ((!this.allowEvolve || !this.isOwnPokemon) && this.pokemon && this.pokemon.evolvable && this.pokemon.evolvable.length > 0) {
                    return {...this.pokemon, evolvable: []};
                }
                return this.pokemon;
            },
            // Ditto v aktivním souboji zobrazuje sprite SOUPEŘE, zbytek
            // používá vlastní typ - sdíleno mezi getIcon a getIconStyle.
            activePokemonType(){
                return (this.pokemon.isDitto && this.opponentPokemon)
                    ? this.opponentPokemon.pokemonType : this.pokemon.pokemonType;
            },
            getIcon(){
                return pokemonImageSrc(this.activePokemonType.img);
            },
            // Origin sprite sada nemá jednotnou orientaci, takže se neřeší
            // podle side napevno, ale podle per-pokémon PokemonType.imgMirror:
            // Left strana zrcadlí přesně když imgMirror JE nastavený, Right
            // strana zrcadlí přesně opačně.
            getIconStyle(){
                const mirror = this.activePokemonType.imgMirror;
                const needsFlip = this.side === 'Left' ? mirror
                    : this.side === 'Right' ? !mirror
                    : false;
                return needsFlip ? {transform: 'scaleX(-1)'} : {};
            },
            // Která hodnota z reportu se týká TOHOTO pokémona (podle side) -
            // trainerPokemonDmg patří Left kartě, opponentPokemonDmg Right kartě.
            hitDmg(){
                if (!this.hitReport) return 0;
                if (this.side === 'Left') return this.hitReport.trainerPokemonDmg || 0;
                if (this.side === 'Right') return this.hitReport.opponentPokemonDmg || 0;
                return 0;
            },
            effectOverlayStyle(){
                return this.side === 'Left'
                    ? {transform: 'translate(-50%, -50%) scaleX(-1)'}
                    : {transform: 'translate(-50%, -50%)'};
            },
            // Jen pro štít - posunuto o 15 procentních bodů od středu (50%)
            // směrem ke středu bojové obrazovky (Left karta -> 65%, Right
            // karta -> 35%). Šířka je počítaná v JS ze zaměřené
            // shieldCardHeightPx (30 % z výšky karty, ne šířky - CSS width
            // nejde vyjádřit jako procento výšky containeru); dokud se první
            // měření nestihne, spadne zpět na CSS "width: 25%" fallback.
            shieldOverlayStyle(){
                const widthPx = this.shieldCardHeightPx
                    ? `${Math.round(this.shieldCardHeightPx * 0.3)}px`
                    : undefined;
                return this.side === 'Left'
                    ? {left: '65%', width: widthPx, transform: 'translate(-50%, -50%) scaleX(-1)'}
                    : {left: '35%', width: widthPx, transform: 'translate(-50%, -50%)'};
            },
            // Je TATO strana (side) v AKTUÁLNÍM kole útočník? attSkill/defSkill
            // patří roli (útočník/obránce), ne straně, takže se musí
            // přemapovat přes beforeAttackRound. Stejná role-based logika
            // jako FightReport.vue::getSkill().
            isAttackerThisRound(){
                if (this.beforeAttackRound === null) return false;
                return (this.side === 'Left' && this.beforeAttackRound)
                    || (this.side === 'Right' && !this.beforeAttackRound);
            },
            // Skill, který TATO strana použila tohle kolo (útočný nebo
            // obranný, podle role) - null u základního útoku ("Base move").
            mySkill(){
                if (!this.hitReport) return null;
                return this.isAttackerThisRound ? this.hitReport.attSkill : this.hitReport.defSkill;
            },
            // Heal i Lifesteal sdílí stejný gif - obojí se pozná podle toho,
            // že TATO strana útočila a její HP tohle kolo stouplo.
            isHealOrLifesteal(){
                return this.isAttackerThisRound
                    && !!(this.mySkill && (this.mySkill.effect === 'HEAL' || this.mySkill.effect === 'LIFESTEAL'));
            },
            // Hra nemá DOT/status poison efekt - "poison zásah" znamená
            // zásah útokem TYPU Poison, čti attType (ne skill.type, ten může
            // být jiný diky METRONOM efektu). Patří výhradně OBRÁNCI - i
            // když se přes REFLECT vlastní poison útok odrazí zpátky jako
            // dmg, to spadá pod běžný hit-impact.
            isPoisonHit(){
                return !!(this.hitReport && !this.isAttackerThisRound && this.hitReport.attType && this.hitReport.attType.id === 'POISON');
            },
            // Úspěšná aktivní obrana (Dodge=1/Shield=2) - TATO strana byla
            // obránce a její obranný skill má defence > 0.
            isShieldBlock(){
                return !this.isAttackerThisRound && !!(this.mySkill && this.mySkill.defence > 0);
            },
            // Reflect varianta úspěšné obrany (Thorn Shield, Fire mirror...) -
            // v datech (attacks.csv) má effect REFLECT vždy defence=DEF_SHIELD,
            // stačí rozšířit isShieldBlock o konkrétní effect.
            isReflectBlock(){
                return this.isShieldBlock && !!(this.mySkill && this.mySkill.effect === 'REFLECT');
            },
            // Probitý štít - útočník měl skill s effect PIERCING proti
            // obránci s DEF_SHIELD a bonus pomohl útoku projít (hitDmg<0 na
            // obránci). Neúspěšný pokus zůstává obyčejný shieldBlock beze
            // změny, protože hitDmg tam zůstane 0.
            isPierceBreak(){
                return !this.isAttackerThisRound
                    && this.hitDmg < 0
                    && !!(this.mySkill && this.mySkill.defence === 2) // PokemonTypeSkill::DEF_SHIELD
                    && !!(this.hitReport && this.hitReport.attSkill && this.hitReport.attSkill.effect === 'PIERCING');
            },
            // Který obrázek se použije uvnitř shieldBlock položky fronty -
            // normální/mirror/pierce sdílí STEJNOU CSS animaci, liší se jen
            // obrázkem (a u pierce absencí lesku).
            shieldOverlayImg(){
                if (this.isPierceBreak) return this.piercePokPng;
                if (this.isReflectBlock) return this.mirrorPokPng;
                return this.shieldPokPng;
            },
            // Omámení se týká OBRÁNCE úspěšného zásahu (viz FightService.php) -
            // TATO strana musí být obránce, aby stunned platilo pro ni.
            isStunnedThisSide(){
                return !this.isAttackerThisRound && !!this.hitReport && this.hitReport.stunned === true;
            },
            // Remíza - obě HP pole 0 A obránce neměl aktivní obranný skill A
            // nešlo o stunned. Stejná podmínka na OBOU stranách - Left i
            // Right instance tak nezávisle dojdou ke stejnému závěru a
            // spustí svůj odlesk současně, bez potřeby sdílené komponenty.
            isMiss(){
                if (!this.hitReport) return false;
                return this.hitReport.trainerPokemonDmg === 0
                    && this.hitReport.opponentPokemonDmg === 0
                    && !(this.hitReport.defSkill && this.hitReport.defSkill.defence > 0)
                    && this.hitReport.stunned !== true;
            },
            activeEffectSrc(){
                return this.activeEffect ? this.battleEffectGifs[this.activeEffect] : null;
            },
            rightHanded() {
                return flags.rightHanded;
            },
        },
        watch: {
            pokemon() {
                if (this.pokemon.skills){
                    this.skills = this.pokemon.skills;
                }
            },
            // hitReport je nový objekt při každém kole - handler rozhodne,
            // který efekt (případně fronta efektů) se má na TÉTO straně přehrát.
            hitReport() {
                if (!this.hitReport) {
                    this.stopStunnedLoop();
                    return;
                }

                // Stunned se stopne, jakmile přestane platit pro TUTO stranu -
                // BE ho resetuje na false na začátku každého kola a znovu
                // nastaví jen při nové úspěšné STUN akci.
                if (!this.isStunnedThisSide) {
                    this.stopStunnedLoop();
                }

                const queue = [];
                if (this.hitDmg < 0) {
                    if (this.isPierceBreak) {
                        queue.push('shieldBlock', 'hitImpact');
                    } else {
                        queue.push('hitImpact');
                    }
                    if (this.isPoisonHit) {
                        queue.push('poisonDrops');
                    }
                } else if (this.hitDmg > 0 && this.isHealOrLifesteal) {
                    queue.push('healLifesteal');
                } else if (this.hitDmg === 0 && this.isShieldBlock) {
                    queue.push('shieldBlock');
                } else if (this.hitDmg === 0 && this.isMiss) {
                    this.playMissStreak();
                }

                if (queue.length > 0) {
                    this.playEffectQueue(queue, this.isStunnedThisSide);
                } else if (this.isStunnedThisSide) {
                    this.startStunnedLoop();
                }
            },
        },
        mounted() {
            // this.$el je komentářový uzel, pokud je "pokemon" undefined
            // (v-if na kořeni) - instanceof Element to bezpečně vyfiltruje.
            if (typeof ResizeObserver !== 'undefined' && this.$el instanceof Element) {
                this.shieldHeightObserver = new ResizeObserver((entries) => {
                    this.shieldCardHeightPx = entries[0].contentRect.height;
                });
                this.shieldHeightObserver.observe(this.$el);
            }
        },
        beforeDestroy() {
            clearTimeout(this.activeEffectTimeout);
            clearTimeout(this.missStreakTimeout);
            if (this.shieldHeightObserver) {
                this.shieldHeightObserver.disconnect();
            }
        },
        created() {
            if (this.pokemon.skills){
                this.skills = this.pokemon.skills;
            }
            if(this.forceSkills) {
                const url = new URL("api/pokemon-skills/{id}".replace('{id}',this.pokemon.id), API_ENTRYPOINT);
                let obj = {url: url, method: 'GET'};
                this.fetchPokemon(obj).then(
                    (data) => {
                        this.skills = data.skills;
                    }
                );
            }
        },
        methods: {
            ...mapActions({
                fetchPokemon: 'pokemon/fetchObject',
                refreshActiveTeam: 'pokemon/refreshActiveTeam',
                evolveEeveeAction: 'trainer/evolveEevee',
            }),
            // Přehraje frontu efektů jeden po druhém, každý po dobu z
            // EFFECT_DURATIONS_MS. Až fronta dojde, volitelně spustí
            // nekonečný stunned loop - používá se, když má stejná strana
            // v tomhle kole zároveň dostat zásah/heal A být stunned.
            playEffectQueue(queue, startStunnedAfter) {
                clearTimeout(this.activeEffectTimeout);
                const playNext = (remaining) => {
                    if (remaining.length === 0) {
                        this.activeEffect = null;
                        if (startStunnedAfter) {
                            this.startStunnedLoop();
                        }
                        return;
                    }
                    const [effect, ...rest] = remaining;
                    this.activeEffect = effect;
                    this.activeEffectKey += 1;
                    this.activeEffectTimeout = setTimeout(() => playNext(rest), EFFECT_DURATIONS_MS[effect]);
                };
                playNext(queue);
            },
            playMissStreak() {
                clearTimeout(this.missStreakTimeout);
                this.showMissStreak = true;
                this.missStreakTimeout = setTimeout(() => {
                    this.showMissStreak = false;
                }, MISS_STREAK_DURATION_MS);
            },
            startStunnedLoop() {
                this.stunnedLoopKey += 1;
                this.showStunnedLoop = true;
            },
            stopStunnedLoop() {
                this.showStunnedLoop = false;
            },
            openSkillDetail(skill) {
                this.selectedSkill = skill;
                this.skillDetailOpen = true;
            },
            getPokemonName() {
              if (this.pokemon.name !== null) {

                  return this.pokemon.name;
              }

              return this.pokemon.pokemonType.name;
            },
            getHp(){
                return parseInt(this.pokemon.hp) / parseInt(this.pokemon.maxHp) * 100;
            },
            toggleStats(){
                // Buy mód čerpá z pokemon.pokemonType.skills (viz
                // displayedSkillItems) - ta data už jsou na propu, žádný
                // fetch netřeba, jen otevřít/zavřít dialog.
                if (this.allowBuySkills) {
                    this.show = !this.show;
                    return;
                }
                if ((this.skills === undefined || this.skills === null) && !this.show) {
                    this.downloadSkills();
                } else {
                    this.show = !this.show;
                }
            },
            downloadSkills() {
                this.loading = true;
                const url = new URL("api/pokemon-skills/{id}".replace('{id}',this.pokemon.id), API_ENTRYPOINT);
                let obj = {url: url, method: 'GET'};
                this.fetchPokemon(obj).then(
                    (data) => {
                        this.skills = data.skills;
                        this.loading = false;
                        this.show = !this.show;
                    }
                );
            },
            chooseToFightButton(pokemon) {
                let backgroundSound = require('@/assets/sounds/choose.mp3');
                let sound = new Audio(backgroundSound);
                sound.volume = this.buttonVolume / 100;
                sound.play();
                this.chooseToFight(pokemon);
            },
            // Nákup nového skillu (jen když allowBuySkills) - stejný
            // endpoint/vzor jako PokemonManager.vue buyNewSkill(). Katalog
            // skillů typu se po nákupu nemění, netřeba refetch - mění se jen
            // pokemon.skillIds/freeExp přes Vuex patch (refreshActiveTeam).
            buyNewSkill(skillId) {
                this.skillBuyLoading = true;
                const url = new URL('api/pokemon-buy-skill', API_ENTRYPOINT);
                const obj = {url: url, method: 'POST', obj: {pokemonId: this.pokemon.id, skillId: skillId}};
                this.fetchPokemon(obj).then(
                    (data) => {
                        this.skillBuyLoading = false;
                        if (data) {
                            this.refreshActiveTeam(data);
                        }
                    }
                );
            },
            // Sdíleno se šablonou (evolve dlaždice, eevee stone popup) -
            // stejný důvod jako PokemonManager.vue evolveImg.
            evolveImg(img) {
                return pokemonImageSrc(img);
            },
            // useItem vraci jen trenerova data, ne pokemona v tvaru, co tahle
            // komponenta ceka (viz stejny duvod u onPokemonUpdated v
            // PokemonSwiper.vue) - plny refetch aktivniho tymu misto patch.
            onItemUsed() {
                this.refreshActiveTeam();
            },
            getTypeStones(type) {
                // Zamcene kameny (viselici v aukcni nabidce) se z evolve pickeru
                // rovnou vyfiltruji - narozdil od Stones.vue tady nema smysl
                // zobrazovat badge/tooltip, jen je nenabizet k pouziti.
                return this.stones.filter(item => item.type.id === type && !item.lockedInTradeOffer);
            },
            evolvePokemon(evolve) {
                if (this.pokemon.pokemonType.number === 133 || this.pokemon.pokemonType.number === 1052 || this.pokemon.pokemonType.number === 1098) {
                    this.dialogStones = this.getTypeStones(evolve.type);
                    this.evolveEvveePokemon = evolve;
                    this.showEeveeStones = true;
                } else {
                    this.sendEvolvePokemon(evolve.id);
                }
            },
            async sendEvolvePokemon(id) {
                let rlyEvolve = await this.$refs.confirmDialog.open(this.$t('pokemon.common.confirmEvolve', {name: this.pokemon.name}), {important: true});
                if (rlyEvolve) {
                    this.loading = true;
                    const url = new URL("api/evolve-pokemon", API_ENTRYPOINT);
                    let obj = {url: url, method: 'POST', obj: {pokemonId: this.pokemon.id, evolveTypeId: id}};
                    this.fetchPokemon(obj).then(
                        (data) => {
                            this.loading = false;
                            if (data) {
                                this.refreshActiveTeam(data);
                            }
                        }
                    );
                }
            },
            async evolveEevee(id, evolveId) {
                let rlyEvolve = await this.$refs.confirmDialog.open(this.$t('pokemon.common.confirmEvolve', {name: this.pokemon.name}), {important: true});
                if (rlyEvolve) {
                    this.loading = true;
                    let obj = {pokemonId: this.pokemon.id, stoneId: id, evolveId: evolveId};
                    this.evolveEeveeAction(obj).then(
                        (data) => {
                            this.loading = false;
                            this.showEeveeStones = false;
                            if (data && data.pokemon) {
                                this.refreshActiveTeam(data.pokemon);
                            }
                        }
                    );
                }
            },
        },
    }
</script>

<style scoped>
/* Zadani uzivatele 2026-08-27 - cislo se v HP baru tesne nevejde cele,
   zmenseno o 1px oproti zdedenemu Vuetify .caption (12px). */
.pd-hp-text {
    font-size: 11px;
}
.pokemon-detail-skills-bg {
    display: flex;
    flex-direction: column;
    min-height: 0;
}
/* Rezerva pro plovoucí zavírací křížek, stejných 69px jako ostatní next/
   popupy - `:full-height="false"` nechá kartu zmenšit se podle obsahu,
   takže u pokémona s málo skilly by křížek bez rezervy překrýval poslední
   řádky. */
.pokemon-detail-skills-content {
    /* !important nutné - Vuetify ".v-dialog > .v-card > .v-card__text" má
       vyšší specificitu (3 třídy) a jinak by náš padding tiše přebilo. */
    padding-bottom: var(--responsive-dialog-close-clearance) !important;
}
@media (min-width: 960px) {
    .pokemon-detail-skills-content {
        padding-bottom: 16px !important;
    }
}
.pokemon-detail-card {
    /* Kotva pro .pokemon-detail-effect-overlay níže - Vuetify v-card sama
       nedává position:relative. */
    position: relative;
    /* Container query níže reaguje na skutečnou šířku KARTY (ne viewportu) -
       viz claude/components/team-sheet.md k celému tier systému. */
    container-type: inline-size;
    /* Base hodnoty (karta > 400px) zamerne kopiruji PokemonManager.vue
       (referencni "you" karta, renderuje vzdy 1:1) - obe karty tak pri
       stejne sirce vypadaji stejne (zadani uzivatele 2026-09-02, drivejsi
       base 0.6-0.8 skaly delaly z Team Board popupu zmenseninu). Skalovani
       dolu zacina az od tieru <=280px (battle karty), viz @container bloky. */
    --pd-text-pad: 16px;
    --pd-name-scale: 1;
    --pd-typepill-scale: 1;
    --pd-level-scale: 1;
    /* Evolve koule má VLASTNÍ škálu, oddělenou od --pd-level-scale - sdílená
       proměnná by při zvětšení evolve koule nechtěně zvětšila i level kouli. */
    --pd-evolve-scale: 1;
    --pd-skills-scale: 1;
    --pd-level-right: 14px;
    --pd-level-bottom: 16px;
    --pd-skills-bottom: 20px;
    /* Vuetify .container má natvrdo padding:12px - 4px tady dava jmeno/HP
       bar na stejny levy inset (text-pad 16 + 4 = 20px) jako badges. */
    --pd-container-pad: 4px;
    /* PokemonCardBadges (typová pilulka/item tlačítko/evolve koule) top/inset -
       stejný tier systém jako --pd-level-right/bottom výše, viz .pokemon-detail-badges. */
    --pd-badges-top: 72px;
    --pd-badges-inset: 20px;
}
@media (min-width: 960px) {
    .pokemon-detail-card {
        /* Na mobilu posílá BattleScreen.vue minHeight="100%" (50/50 split
           karty/report, .battle-layout__row má definitivní výšku). Na
           desktopu ale .battle-layout__row zůstává auto-vysoký, takže "100%"
           by neměla vůči čemu se počítat a karta by zkolabovala na 0px. */
        height: 400px !important;
    }
}
.pokemon-detail-icon {
    margin: 12px;
    padding: 12px;
    /* Vuetify v-responsive nastavuje "width:100%" inline stylem (kotva je
       position:absolute; left:0 v šabloně, containing block = celá karta) -
       bez odečtu marginu od 100% šířky karta na užších kartách vodorovně
       "přetékala" (scrollWidth > clientWidth i přesto, že vizuálně nic
       nebylo vidět - hlášeno uživatelem 2026-09-02, "Team Board popup jde
       vodorovně scrollovat"). !important nutné, jinak inline styl vyhraje. */
    width: calc(100% - 24px) !important;
}
/* PokemonLevelBadge dědí velikost/odsazení level bubliny z existujícího
   container-query systému (--pd-level-*) přes vlastní --plb-level-*
   proměnné - viz tier bloky níže. --plb-level-scale škáluje POUZE bublinu
   (PokemonLevelBadge.vue aplikuje zoom jen na .pokemon-level-badge__level) -
   exp pilulka je záměrně NEškálovaná, ať je text čitelný stejně jako v
   PokemonManager.vue (dřív se zoomovala spolu s bublinou a zvětšení fontu
   v PokemonLevelBadge.vue se na Team Boardu prakticky ztratilo - hlášeno
   uživatelem 2026-09-02). Exp pilulka patří vizuálně na stranu Skilly
   tlačítka (design spec), NE na stranu level bubliny - --plb-exp-inset proto
   NENÍ odvozené z --pd-level-right (to je inset OPAČNÉ strany), ale je to
   samostatná konstanta doladěná přes Playwright tak, aby pilulka seděla
   těsně vedle Skilly (to má fixní left:8px/zoom nezávisle na tier - viz
   .pokemon-detail-skills-wrap níže - proto stačí jedna konstanta, ne
   tier-závislá proměnná). --plb-exp-bottom sdílí --pd-skills-bottom se
   Skilly tlačítkem, ať jsou přibližně na stejné výšce. */
.pokemon-detail-level-badge {
    --plb-level-inset: var(--pd-level-right, 14px);
    --plb-level-bottom: var(--pd-level-bottom, 16px);
    --plb-level-scale: var(--pd-level-scale, 1);
    --plb-exp-inset: 100px;
    /* +4px stejne jako v PokemonManager.vue (exp-bottom 24 vs. skills 20) -
       pilulka a tlacitko maji priblizne zarovnane zakladny. */
    --plb-exp-bottom: calc(var(--pd-skills-bottom, 20px) + 4px);
}
/* Skilly tlačítko + "může se naučit skill" hvězdička sdílí jeden
   position:absolute wrapper - hvězdička je uvnitř pozičně vázaná na roh
   tlačítka (viz .pokemon-detail-skills-star), místo dvou nezávisle
   doladěných absolutních offsetů, které se dřív rozjížděly (hvězdička
   "utíkala" mimo pilulku - hlášeno uživatelem 2026-09-02). Inset 20px =
   stejný jako badges/name/exp, škála přes tier proměnnou (base 1 = stejné
   tlačítko jako PokemonManager.vue). */
.pokemon-detail-skills-wrap {
    position: absolute;
    bottom: var(--pd-skills-bottom, 20px);
    left: 20px;
    zoom: var(--pd-skills-scale, 1);
}
.pokemon-detail-skills-wrap--mirrored {
    left: auto;
    right: 20px;
}
/* Hvezdicka na hornim rohu tlacitka - vetsina plochy NA tlacitku, kousek
   precniva ("soucast tlacitka", zadani uzivatele 2026-09-02).
   pointer-events:none, at neblokuje klik na roh tlacitka pod sebou. */
.pokemon-detail-skills-star {
    position: absolute !important;
    top: 0;
    right: 0;
    transform: translate(25%, -35%);
    z-index: 1;
    pointer-events: none;
    color: #FFD700 !important;
    filter: drop-shadow(0 0 3px rgba(0,0,0,0.9)) drop-shadow(0 0 3px rgba(0,0,0,0.9));
}
.pokemon-detail-skills-wrap--mirrored .pokemon-detail-skills-star {
    right: auto;
    left: 0;
    transform: translate(-25%, -35%);
}
/* PokemonCardBadges dedi top/inset + skalu z existujiciho container-query
   systemu (--pd-typepill-scale/--pd-evolve-scale) pres vlastni --pcb-*
   promenne - trida misto inline stylu, aby ji sly prepsat @container bloky
   nize (inline style by mel vzdy prednost pred tridou). */
.pokemon-detail-badges {
    --pcb-top: var(--pd-badges-top, 72px);
    --pcb-inset: var(--pd-badges-inset, 20px);
    --pcb-badge-scale: var(--pd-typepill-scale, 1);
    --pcb-evolve-scale: var(--pd-evolve-scale, 1);
}
/* Bojové efekty na středu karty pokémona. Zrcadlení řeší effectOverlayStyle
   computed, jen pro Left stranu. pointer-events:none, ať nepřekáží klikání
   na kartu/Skills tlačítko pod ním. mix-blend-mode:screen jen pro hit-impact
   (černé pozadí, "additive" export formát) - novější gify mají reálnou alfu. */
.pokemon-detail-effect-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 106%;
    max-width: 384px;
    pointer-events: none;
    z-index: 20;
}
.pokemon-detail-effect-overlay--screen {
    mix-blend-mode: screen;
}
/* Novější efekty (heal-lifesteal/poison-drops) mají nativní rozlišení
   zdrojových gifů jen 150x150 - na rozdíl od hit-impact.gif (480x270,
   zůstává na základní 384px velikosti výše). Strop 150px = 1:1 s nativním
   rozlišením, žádné škálování nahoru. */
.pokemon-detail-effect-overlay--compact {
    width: 100%;
    max-width: 150px;
}
/* Štít škálovaný relativně k velikosti karty (width přebité inline stylem
   ze shieldOverlayStyle computed - 30 % z výšky karty). width:25% tady je
   jen FALLBACK pro okamžik před prvním ResizeObserver měřením. max-width
   150px zůstává jako pojistka proti pixelaci na velkých kartách. */
.pokemon-detail-effect-overlay--shield {
    width: 25%;
    max-width: 150px;
}
/* Štít - statický obrázek, animovaný samostatně od wrapperu (ten je jen
   pozicní/zrcadlicí). animation:forwards drží poslední keyframe (opacity:0)
   po skončení - nevadí, JS timeout (přesně 1500ms = délka animace) element
   stejně v tu chvíli odstraní z DOM. */
.pokemon-detail-shield-img {
    display: block;
    width: 100%;
    height: auto;
    animation: pokemon-detail-shield-appear 1.5s ease-in-out forwards;
}
/* Lesk přes štít - mask-image maskuje gradientový pruh na přesnou siluetu
   štítu (stejné png jako obrázek), bez masky by byl lesk vidět jako
   obdélník i mimo tvar štítu. */
.pokemon-detail-shield-shine {
    position: absolute;
    inset: 0;
    overflow: hidden;
    -webkit-mask-size: contain;
    mask-size: contain;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
}
.pokemon-detail-shield-shine::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -60%;
    width: 35%;
    height: 200%;
    background: linear-gradient(100deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.95) 50%, rgba(255,255,255,0) 100%);
    transform: rotate(12deg);
    opacity: 0;
    animation: pokemon-detail-shield-shine-sweep 1.5s ease-in-out forwards;
}
/* Sekvence: štít se OBJEVÍ (0-18 %, fade+scale z 0.7 na 1), ZACHVĚJE se
   (18-50 %, rotate wobble), drží (shine běží souběžně přes shine-sweep
   animaci níže), a nakonec ZMIZÍ (85-100 %, fade out). Časování v % z 1.5s,
   MUSÍ zůstat synchronizované s EFFECT_DURATIONS_MS.shieldBlock. */
@keyframes pokemon-detail-shield-appear {
    0% { opacity: 0; transform: scale(0.7); }
    18% { opacity: 1; transform: scale(1) rotate(0deg); }
    26% { transform: scale(1) rotate(-6deg); }
    32% { transform: scale(1) rotate(6deg); }
    38% { transform: scale(1) rotate(-4deg); }
    44% { transform: scale(1) rotate(4deg); }
    50% { opacity: 1; transform: scale(1) rotate(0deg); }
    85% { opacity: 1; transform: scale(1) rotate(0deg); }
    100% { opacity: 0; transform: scale(1) rotate(0deg); }
}
/* Zalesknutí běží až po doznění zachvění (45-80 % z 1.5s), ať se opticky
   nepřekrývá se shake fází výše. */
@keyframes pokemon-detail-shield-shine-sweep {
    0%, 45% { opacity: 0; left: -60%; }
    50% { opacity: 1; }
    75% { left: 120%; opacity: 1; }
    80%, 100% { opacity: 0; left: 120%; }
}
/* Stunned hvězdičky - zmenšeno na polovinu --compact velikosti, posunuto do
   horní třetiny karty (tam kde bývá hlava pokémona). left:50% z
   effectOverlayStyle už řeší horizontální střed. Musí být AŽ ZA --compact v
   souboru, aby width/max-width převážily při stejné specificitě. */
.pokemon-detail-effect-overlay--stunned {
    top: 33%;
    width: 50%;
    max-width: 75px;
}
/* Remíza - bílý diagonální odlesk, co jednou přejede přes kartu. Čistý CSS,
   žádný gif - overflow:hidden na obalu ořízne pruh na hranice karty, ::after
   samotný pruh animuje přes celou její šířku. */
.pokemon-detail-miss-streak {
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 20;
    overflow: hidden;
}
.pokemon-detail-miss-streak::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -60%;
    width: 40%;
    height: 200%;
    background: linear-gradient(100deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.85) 50%, rgba(255,255,255,0) 100%);
    transform: rotate(12deg);
    animation: pokemon-detail-miss-streak-sweep 0.4s ease-out;
}
@keyframes pokemon-detail-miss-streak-sweep {
    from { left: -60%; }
    to { left: 120%; }
}
.pokemon-detail-text {
    padding-left: var(--pd-text-pad, 16px);
    padding-right: var(--pd-text-pad, 16px);
}
.pokemon-detail-name-wrap {
    padding: var(--pd-container-pad, 12px);
    /* Sloupcový flex + pevný gap místo ručních "top" pull-offsetů - flex gap
       řeší přesnou mezeru vždy, nezávisle na aktuálním zoomu jednotlivých
       prvků na užších kartách (viz @container bloky níže). */
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
}
/* Evolve bar / HP bar / level bar "přitisknuté" na sebe bez mezery -
   vlastní vnořený flex sloupec s gap:0 (.pokemon-detail-name-wrap gap:2px
   výše platí jen mezi tímhle blokem jako celkem a jménem pod ním). */
.pokemon-detail-hp-stack {
    display: flex;
    flex-direction: column;
    gap: 0;
    width: 100%;
}
/* Pět úrovní podle šířky KARTY (container query, ne viewport) - viz
   claude/components/team-sheet.md pro celkový návrh tier systému. Base
   (>400px) = výchozí hodnoty proměnných na .pokemon-detail-card výše.
   Cíl je vždy .pokemon-detail-text (potomek), NE .pokemon-detail-card - ten
   je sám containerem a nemůže být velikostně podmíněný sám sebou. Pořadí
   bloků od nejširšího po nejužší - při stejné specificitě vyhrává poslední
   odpovídající pravidlo. */
@container (max-width: 400px) {
    /* Team Board popup / Oak popup na mobilu (~270-340px karta) - ZADNE
       skalovani, prvky maji stejne rozmery jako v PokemonManager.vue pri
       stejne sirce karty (zadani uzivatele 2026-09-02: "proc nejsou
       stejne?!"). Skaly dedi 1 z base, prepisuji se jen paddingy. */
    .pokemon-detail-text {
        --pd-text-pad: 13px;
        --pd-container-pad: 7px;
    }
}
@container (max-width: 280px) {
    /* Mezistupen mezi plnou velikosti (>=280) a battle tierem (<=160). */
    .pokemon-detail-text {
        --pd-text-pad: 10px;
        --pd-name-scale: 0.8;
        --pd-typepill-scale: 0.85;
        --pd-level-scale: 0.7;
        --pd-evolve-scale: 0.72;
        --pd-skills-scale: 0.85;
        --pd-level-right: 10px;
        --pd-level-bottom: 10px;
        --pd-skills-bottom: 10px;
        --pd-container-pad: 5px;
        --pd-badges-top: 56px;
        --pd-badges-inset: 12px;
    }
}
@container (max-width: 160px) {
    .pokemon-detail-text {
        --pd-text-pad: 4px;
        --pd-name-scale: 0.44;
        --pd-typepill-scale: 0.72;
        --pd-level-scale: 0.45;
        --pd-evolve-scale: 0.6;
        /* 28px (small btn) * 0.72 = ~20px, stejna vysledna vyska Skilly
           tlacitka v boji jako pred prechodem na `small` + tier skalu. */
        --pd-skills-scale: 0.72;
        --pd-level-right: 6px;
        --pd-level-bottom: 6px;
        --pd-skills-bottom: 3px;
        --pd-container-pad: 4px;
        --pd-badges-top: 26px;
        --pd-badges-inset: 3px;
    }
}
@container (max-width: 140px) {
    /* Nejmenší reálný případ (viewport ~340-380px, dvě karty vedle sebe v
       boji). Level bublina zůstává viditelná - dědí scale/right/bottom z
       @container (max-width: 160px) výše, protože tady se nepřepisují. */
    .pokemon-detail-text {
        --pd-text-pad: 4px;
        --pd-name-scale: 0.4;
        --pd-typepill-scale: 0.68;
        --pd-level-right: 4px;
        --pd-level-bottom: 4px;
        --pd-skills-bottom: 2px;
        --pd-container-pad: 3px;
        --pd-badges-top: 18px;
        --pd-badges-inset: 2px;
    }
}
</style>

